import _ from 'lodash'

import { Stack } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'
import { AdminEstablishmentTabEnum, EstablishmentTabs, useEstablishmentTab } from './components/EstablishmentTabs'
import { EditEstablishment } from './components/EditEstablishment'
import PluginsPage from '../plugins/PluginsPage'

export function EstablishmentPage() {
  const tab = useEstablishmentTab()

  return (
    <PageContainer>
      <Stack spacing={2}>
        <EstablishmentTabs />
        {tab === AdminEstablishmentTabEnum.EDIT && <EditEstablishment />}
        {tab === AdminEstablishmentTabEnum.PLUGINS && <PluginsPage />}
      </Stack>
    </PageContainer>
  )
}
